<template>
    <!-- SECTION: Template -->
    <div class="sub-page">
        <!-- ANCHOR: PageTitle -->
        <PageTitle
            main-title="공지사항"
            sub-title="레코스의 새로운 소식과 이벤트"
            bg-color=""
        />

        <!-- ANCHOR: 상세 -->
        <section class="c-section d-flex justify-center">
            <div class="c-contanier">
                <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        lg="8"
                        md="10"
                        sm="12"
                        class="notice-view"
                    >
                        <!-- 게시물 정보 -->
                        <div v-if="currentNoticeItem">
                            <p class="le-heading6">
                                {{ currentNoticeItem.title }}
                            </p>

                            <p class="le-text-body2">
                                {{ formatDate(currentNoticeItem.publishedDate) }}
                            </p>
                        </div>

                        <!-- 게시물 콘텐츠 (Admin에서 작성한 HTML) -->
                        <div class="notice-view__content my-15">
                            <div
                                v-if="currentNoticeItem"
                                class="editor-content"
                                v-html="normalizedNoticeHtml"
                            />
                            <div
                                v-else
                                class="le-text-body2"
                            >
                                게시물을 찾을 수 없습니다.
                            </div>
                        </div>

                        <!-- 목록 버튼 -->
                        <div class="d-flex justify-center">
                            <v-btn
                                :to="{ name: 'NoticePage' }"
                                color="orange1"
                                depressed
                                :small="$vuetify.breakpoint.smAndDown"
                                :large="$vuetify.breakpoint.mdAndUp"
                                class="text-white1"
                            >
                                목록으로
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </section>
    </div>
    <!-- !SECTION: Template -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import { getNoticeMetaInfo } from '@/utils/metaInfo.js';
import PageTitle from '@/components/PageTitle.vue';

export default {
    name: 'NoticeViewPage',
    components: {
        PageTitle,
    },

    // metaInfo() {
    //     return getNoticeMetaInfo(this);
    // },

    data() {
        return {};
    },

    computed: {
        // getNoticeItem: (id) => NoticeResponse
        ...mapGetters('notice', ['getNoticeItem']),

        currentNoticeItem() {
            const id = this.$route.query.id;
            return id ? this.getNoticeItem(id) : null;
        },

        /* ============================================================
        * ANCHOR: HTML 내 이미지 경로 보정 (User Front)
        *  - DB에는 src="/upload/..." 형태(상대경로)로 저장되어 있음
        *  - User 사이트에서 v-html 렌더링 시, 브라우저는 이를
        *    현재 도메인(예: http://localhost:8888/upload/...) 기준으로 요청해서 엑박이 뜸
        *  - 그래서 렌더링할 때만 유저 백엔드(baseURL: 7243)를 붙여서 보여준다.
        * ============================================================ */
        userImageBaseUrl() {
            // 예: https://localhost:7243
            return (process.env.VUE_APP_IMAGE_BASE_URL || '').replace(/\/$/, '');
        },

        normalizedNoticeHtml() {
            const html = this.currentNoticeItem?.contentHtml || '';
            if (!html) return html;

            // src="/upload/..."  →  src="https://localhost:7243/upload/..."
            // 작은따옴표/큰따옴표 둘 다 대응
            return html
                .replace(/src="\/upload\//g, `src="${this.userImageBaseUrl}/upload/`)
                .replace(/src='\/upload\//g, `src='${this.userImageBaseUrl}/upload/`);
        },
    },

    created() {
        const id = this.$route.query.id;
        if (id) {
            // 새로고침 등으로 store가 비어 있을 때 대비
            this.fetchNoticeById(id);
        }
    },

    methods: {
        ...mapActions('notice', ['fetchNoticeById']),

        formatDate(value) {
            if (!value) return '';
            return String(value).substring(0, 10);
        },
    },
};
</script>
